import { useMemo } from 'react';
import usePdpLayout from '@hooks/product/use-pdp-layout';
import { useRouter } from 'next/router';

const useHeroPdpStyles = () => {
  const { query } = useRouter();
  const isHeroPDP = query?.product_id ?? '';
  const { isRecirculation } = usePdpLayout();

  const isHeroPdpStyles = useMemo(() => {
    return isHeroPDP || isRecirculation;
  }, [query, isRecirculation]);

  return { isHeroPdpStyles, isHeroPDP };
};
export default useHeroPdpStyles;
